<template>
  <input
    type="text"
    :dataType="dataType"
    :value="modelValue"
    :disabled="disabled"
    :placeholder="placeholder"
    @input="changeInput"
    @paste="onPaste"
    pattern="[0-9]*"
    ref="inputCurrencyRef"
  />
</template>

<script setup>
// eslint-disable-next-line
import { defineProps, defineEmits, ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    require: true,
    description: 'Type of data',
  },
  dataType: {
    type: String,
    require: false,
    default: 'currency',
    validator(value) {
      return ['currency'].includes(value);
    },
  },
  type: {
    type: String,
    default: 'decimal',
    require: false,
    validator(value) {
      return ['decimal', 'integer'].includes(value);
    },
  },
  disabled: {
    type: Boolean,
    require: false,
    default: false,
    description: 'Allow change value',
  },
  placeholder: {
    type: String,
    require: false,
    default: '例：123',
    description: 'Placeholder for input',
  },
  max: {
    type: Number,
    require: false,
    default: 0,
    description: 'Max value',
  },
  autofocus: {
    type: Boolean,
    require: false,
    default: false,
    description: 'auto focus input when loaded'
  }
});

const emit = defineEmits(['update:modelValue']);
const inputCurrencyRef = ref();

const formatNumber = (n) => n?.replace(/\D/g, '')?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

watch(() => props.modelValue, (newVal, oldVal) => {
  if (props.max && +(newVal.replace(/,/g, '')) > props.max) {
    emit('update:modelValue', oldVal);
  }
});

const isSmallerMax = (num) => {
  if (num > props.max) {
    return num.slice(0, num.length - 1);
  }
  return num;
};

const isInteger = (num) => {
  const isInt = /^[1-9]+([0-9]*)$/.test(num);
  if (!isInt) return false;
  if (props.max) {
    return isSmallerMax(num);
  }
  return true;
};

const onPaste = (evt) => {
  evt.preventDefault();
  const copyValue = evt.clipboardData.getData('text');
  if (isInteger(copyValue)) {
    evt.clipboardData.setData('text/plain', formatNumber(copyValue));
    emit('update:modelValue', formatNumber(copyValue));
  }
};

const formatDecimal = (num, type = 'remove') /* input || remove */ => {
  const decimalPosition = num.indexOf('.');
  let leftSide = num;
  let rightSide = '';
  if (decimalPosition > -1) {
    leftSide = num.substring(0, decimalPosition);
    rightSide = num.substring(decimalPosition);
  }
  leftSide = formatNumber(leftSide);
  rightSide = formatNumber(rightSide);
  rightSide = rightSide.substring(0, 2);
  if (type === 'remove' && rightSide.length === 0) {
    num = leftSide;
  } else {
    num = `${leftSide}.${rightSide}`;
  }
  return num;
};

/* eslint-disable */
const changeInput = ($event) => {
  const inputCurrency = inputCurrencyRef.value;
  let inputVal = inputCurrency.value;
  inputVal = inputVal.replace(/,/g, '');
  if (inputVal[0] && inputVal[0] === '0') {
    inputVal = inputVal.substring(1);
  }
  if (props.max) {
    inputVal = isSmallerMax(inputVal)
  }
  if (props.type === 'integer') {
    inputVal = formatNumber(inputVal);
  } else {
    if (('' + inputVal).indexOf('.') >= 0) {
      inputVal = formatDecimal(inputVal, 'input');
    } else {
      inputVal = formatNumber(inputVal);
    }
  }

  inputCurrency.value = inputVal;
  emit('update:modelValue', inputVal);
};
</script>
